/**
 * Shared constants and utilities for Clinical AI Agent components
 */

// Severity badge colors
export const SEVERITY_COLORS = {
  critical: "bg-red-500/20 text-red-400 border-red-500/30",
  high: "bg-orange-500/20 text-orange-400 border-orange-500/30",
  moderate: "bg-yellow-500/20 text-yellow-400 border-yellow-500/30",
  low: "bg-green-500/20 text-green-400 border-green-500/30",
  info: "bg-blue-500/20 text-blue-400 border-blue-500/30"
};

// Transfer types
export const TRANSFER_TYPES = [
  { value: "home_to_facility", label: "Home to Facility" },
  { value: "facility_to_home", label: "Facility to Home" },
  { value: "facility_to_facility", label: "Facility to Facility" },
  { value: "hospital_admission", label: "Hospital Admission" },
  { value: "hospital_return", label: "Return from Hospital" }
];

// Discharge types
export const DISCHARGE_TYPES = [
  { value: "live_discharge", label: "Live Discharge" },
  { value: "death_discharge", label: "Death Discharge" },
  { value: "revocation", label: "Revocation" },
  { value: "transfer_out", label: "Transfer Out" }
];

// Condition change types
export const CONDITION_CHANGE_TYPES = [
  { value: "symptom_escalation", label: "Symptom Escalation" },
  { value: "fall", label: "Fall" },
  { value: "skin_breakdown", label: "Skin Breakdown" },
  { value: "new_infection", label: "New Infection" },
  { value: "pain_escalation", label: "Pain Escalation" },
  { value: "functional_decline", label: "Functional Decline" },
  { value: "caregiver_concern", label: "Caregiver Concern" }
];

// Teaching topics
export const TEACHING_TOPICS = [
  { value: "infection_control", label: "Infection Control" },
  { value: "pain_management", label: "Pain Management" },
  { value: "comfort_kit", label: "Comfort Kit Use" },
  { value: "symptom_management", label: "Symptom Management" },
  { value: "caregiver_self_care", label: "Caregiver Self-Care" },
  { value: "end_of_life_signs", label: "End of Life Signs" },
  { value: "medication_safety", label: "Medication Safety" }
];

// Audience options
export const AUDIENCE_OPTIONS = [
  { value: "nurse", label: "Nurse" },
  { value: "caregiver", label: "Caregiver" },
  { value: "facility", label: "Facility Staff" },
  { value: "patient", label: "Patient" }
];

// Pain qualities
export const PAIN_QUALITIES = [
  { value: "aching", label: "Aching" },
  { value: "sharp", label: "Sharp" },
  { value: "dull", label: "Dull" },
  { value: "burning", label: "Burning" },
  { value: "stabbing", label: "Stabbing" },
  { value: "throbbing", label: "Throbbing" },
  { value: "pressure", label: "Pressure" },
  { value: "cramping", label: "Cramping" }
];

// Common infection symptoms
export const INFECTION_SYMPTOMS = [
  "Fever",
  "Chills",
  "Increased heart rate",
  "Confusion/altered mental status",
  "Redness",
  "Swelling",
  "Warmth at site",
  "Purulent drainage",
  "Odor",
  "Increased pain"
];

// Urinary symptoms
export const URINARY_SYMPTOMS = [
  "Dysuria",
  "Frequency",
  "Urgency",
  "Cloudy urine",
  "Foul-smelling urine",
  "Hematuria",
  "Suprapubic pain"
];

// Respiratory symptoms
export const RESPIRATORY_SYMPTOMS = [
  "Productive cough",
  "Increased secretions",
  "Dyspnea",
  "Abnormal lung sounds",
  "Increased oxygen needs",
  "Wheezing"
];

// Comfort kit types
export const COMFORT_KIT_TYPES = [
  { value: "standard", label: "Standard" },
  { value: "symptom_specific", label: "Symptom Specific" },
  { value: "pediatric", label: "Pediatric" }
];

// Caregiver comfort levels
export const CAREGIVER_COMFORT_LEVELS = [
  { value: "comfortable", label: "Comfortable" },
  { value: "needs_training", label: "Needs Training" },
  { value: "hesitant", label: "Hesitant" }
];

// Voice assessment types
export const VOICE_ASSESSMENT_TYPES = [
  { value: "pain", label: "Pain Assessment" },
  { value: "infection", label: "Infection Assessment" },
  { value: "decline", label: "Decline Assessment" },
  { value: "teaching", label: "Teaching Documentation" },
  { value: "general", label: "General Notes" }
];

// Visit types for supervisory
export const SUPERVISORY_VISIT_TYPES = [
  { value: "routine", label: "Routine 14-Day" },
  { value: "unscheduled", label: "Unscheduled" },
  { value: "change_in_condition", label: "Change in Condition" }
];

// API URL
export const API_URL = process.env.REACT_APP_BACKEND_URL;

// Get severity badge class
export const getSeverityClass = (severity) => {
  return SEVERITY_COLORS[severity] || SEVERITY_COLORS.info;
};
